import firebase from "firebase/app";
import "firebase/storage";
import "firebase/functions";
import "firebase/messaging";
import firebaseConfig from "./firebaseConfig.json";

// Initializes the firebase app.
firebase.initializeApp(firebaseConfig);

// Configures the cache to be unlimited and have no cleanup process.
const g_firestore = firebase.firestore();
const g_auth      = firebase.auth();
const g_functions = firebase.functions();

let g_messaging = null;

try {
    g_messaging = firebase.messaging();
} catch(error) {
    console.warn("[firebase messaging] failed to load", error);
}

if (process.env.NODE_ENV === "development" || location.hostname === "localhost") {
  g_firestore.useEmulator("localhost", 8081);
  g_auth.useEmulator("http://localhost:9099");
  g_functions.useEmulator("localhost", 5001);
} else {
  g_firestore.settings({
    cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
  });

  g_firestore.enablePersistence().then(() => {
    g_firestore.enablePersistence({ experimentalForceOwningTab: true });
  });
}

export const messaging_pub_key = "BDSoJfvioIqUBKDjluHzTAYByBp_5El0TXqgJ6Tm6bsX9ob7vGmGLLTwCJKRwTOGpyxjPT0WmpNiE9_LU32wogI";
export const messaging         = g_messaging;
export const storage           = firebase.storage();
export const auth              = g_auth;
export const firestore         = g_firestore;
export const functions         = g_functions;

export const createUser        = functions.httpsCallable('createUser');
